var map = {
	"./activedirectory.svg": 1821,
	"./adfs.svg": 1822,
	"./azuread.svg": 1823,
	"./custom.svg": 861,
	"./email.svg": 553,
	"./freeipa.svg": 1824,
	"./github.svg": 1825,
	"./googleoauth.svg": 1826,
	"./grafana.svg": 1482,
	"./jaeger.svg": 1483,
	"./keycloak.svg": 1827,
	"./kiali.svg": 1484,
	"./linux.svg": 1828,
	"./longhorn.svg": 1485,
	"./neuvector.svg": 1486,
	"./okta.svg": 1829,
	"./openldap.svg": 1830,
	"./pagerduty.svg": 859,
	"./ping.svg": 1831,
	"./prometheus.svg": 1487,
	"./shibboleth.svg": 1832,
	"./slack.svg": 858,
	"./webhook.svg": 860,
	"./windows.svg": 1833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1140;